var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewindBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2567_901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3851 28.7477C22.2163 33.579 30.0493 33.579 34.8806 28.7477C39.7118 23.9165 39.7118 16.0835 34.8806 11.2523C30.0493 6.421 22.2163 6.421 17.3851 11.2523C14.9679 13.6694 13.7601 16.838 13.7616 20.0061L13.7616 22.7492",
    stroke: "#F1F7FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5335 20.9641L13.7964 23.227L16.0593 20.9641",
    stroke: "#F1F7FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2567_901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "matrix(-1 0 0 1 40 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewindBack);
export default __webpack_public_path__ + "static/media/RewindBack.b438c227cc0f93f3a86fdd4d937957f0.svg";
export { ForwardRef as ReactComponent };